import styled, { css } from 'styled-components';
import { OVERLAY_MIN_HEIGHT } from '@/app/components/search/components/Card/constants.ts';
import {
  CARD_DESKTOP_ROUNDING,
  OVERLAY_WIDTH,
  OVERLAY_WIDTH_EVOLUTION,
} from '@/app/components/search/components/EvolutionCard/constants.ts';

export const BlankContainer = styled.div<{ evolutionResultsOnlyEnabled?: boolean }>`
  ${({ evolutionResultsOnlyEnabled }) =>
    evolutionResultsOnlyEnabled &&
    css`
      border-radius: ${CARD_DESKTOP_ROUNDING};
    `};

  @media (max-width: 767px) {
    width: calc(100vw - 32px);
  }

  @media (min-width: 768px) {
    width: ${({ evolutionResultsOnlyEnabled }) =>
      evolutionResultsOnlyEnabled ? OVERLAY_WIDTH_EVOLUTION : OVERLAY_WIDTH};
    min-height: ${OVERLAY_MIN_HEIGHT};
  }
`;
